// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"Jo-z","imageAndVideoCount":"Ko-z","imageAndVideoContainer":"Lo-z","viewAllReviews":"Mo-z"};